import React, { useState, useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext'; // Import your AuthContext
import Account from '../components/Account';


const CableTV = () => {
    const { buyCableTV, currentUser, fetchNotifications } = useContext(AuthContext); // Access the function and currentUser
    const [smartcardNumber, setSmartcardNumber] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [variationId, setVariationId] = useState('');
    const [serviceId, setServiceId] = useState('gotv'); // default service
    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState({});
    const smartcardRef = useRef(null);
    const phoneRef = useRef(null);
    const serviceRef = useRef(null);
    const planRef = useRef(null);

    const navigate = useNavigate();

    // Mapping of plans to their respective amounts
    const priceMapping = {
        dstv: {
            "dstv-padi": 4400,
            "dstv-yanga": 6000,
            "dstv-confam": 11000,
            "dstv6": 14900, // DStv Asia
            "dstv79": 19000, // DStv Compact
            "dstv7": 30000, // DStv Compact Plus
            "dstv3": 44500, // DStv Premium
            "dstv10": 50500, // DStv Premium Asia
            "dstv9": 69000, // DStv Premium French
            "confam-extra": 17000, // Confam + ExtraView
            "yanga-extra": 12000, // Yanga + ExtraView
            "padi-extra": 10400, // Padi + ExtraView
            "com-asia": 12500, // Compact + Asia
            "dstv30": 44900, // Compact + Extra View
            "com-frenchtouch": 37000, // Compact + French Touch
            "dstv33": 50500, // Premium – Extra View
            "dstv40": 44900, // Compact Plus – Asia
            "com-frenchtouch-extra": 12500, // Compact + French Touch + ExtraView
            "com-asia-extra": 13500, // Compact + Asia + ExtraView
            "dstv43": 12000, // Compact Plus + French Plus
            "complus-frenchtouch": 12500, // Compact Plus + French Touch
            "dstv45": 11000, // Compact Plus – Extra View
            "complus-french-extraview": 50500, // Compact Plus + French Plus + Extra View
            "dstv47": 36290, // Compact + French Plus
            "dstv48": 50900, // Compact Plus + Asia + ExtraView
            "dstv61": 56500, // Premium + Asia + Extra View
            "dstv62": 75000, // Premium + French + Extra View
            "hdpvr-access-service": 6000, // HDPVR Access
            "frenchplus-addon": 6500, // French Plus Add-on
            "asia-addon": 14900, // Asian Add-on
            "frenchtouch-addon": 7000, // French Touch Add-on
            "extraview-access": 6000, // ExtraView Access
            "french11": 10800 // French 11
        },

        gotv: {
            "gotv-smallie": 1900,
            "gotv-jinja": 3900,
            "gotv-jolli": 5800,
            "gotv-max": 8500,
        },
        startimes: {
            "nova": 2100,
            "basic": 5100,
            "smart": 3500,
            "classic": 6000,
        },
    };

    // Cable plans for selection
    const cablePlans = {
        dstv: [
            { id: "dstv-padi", name: "DStv Padi" },
            { id: "dstv-yanga", name: "DStv Yanga" },
            { id: "dstv-confam", name: "DStv Confam" },
            { id: "dstv6", name: "DStv Asia" },
            { id: "dstv79", name: "DStv Compact" },
            { id: "dstv7", name: "DStv Compact Plus" },
            { id: "dstv3", name: "DStv Premium" },
            { id: "dstv10", name: "DStv Premium Asia" },
            { id: "dstv9", name: "DStv Premium-French" },
            { id: "confam-extra", name: "DStv Confam + ExtraView" },
            { id: "yanga-extra", name: "DStv Yanga + ExtraView" },
            { id: "padi-extra", name: "DStv Padi + ExtraView" },
            { id: "com-asia", name: "DStv Compact + Asia" },
            { id: "dstv30", name: "DStv Compact + Extra View" },
            { id: "com-frenchtouch", name: "DStv Compact + French Touch" },
            { id: "dstv33", name: "DStv Premium – Extra View" },
            { id: "dstv40", name: "DStv Compact Plus – Asia" },
            { id: "com-frenchtouch-extra", name: "DStv Compact + French Touch + ExtraView" },
            { id: "com-asia-extra", name: "DStv Compact + Asia + ExtraView" },
            { id: "dstv43", name: "DStv Compact Plus + French Plus" },
            { id: "complus-frenchtouch", name: "DStv Compact Plus + French Touch" },
            { id: "dstv45", name: "DStv Compact Plus – Extra View" },
            { id: "complus-french-extraview", name: "DStv Compact Plus + FrenchPlus + Extra View" },
            { id: "dstv47", name: "DStv Compact + French Plus" },
            { id: "dstv48", name: "DStv Compact Plus + Asia + ExtraView" },
            { id: "dstv61", name: "DStv Premium + Asia + Extra View" },
            { id: "dstv62", name: "DStv Premium + French + Extra View" },
            { id: "hdpvr-access-service", name: "DStv HDPVR Access Service" },
            { id: "frenchplus-addon", name: "DStv French Plus Add-on" },
            { id: "asia-addon", name: "DStv Asian Add-on" },
            { id: "frenchtouch-addon", name: "DStv French Touch Add-on" },
            { id: "extraview-access", name: "ExtraView Access" },
            { id: "french11", name: "DStv French 11" }
        ],
        gotv: [
            { id: "gotv-smallie", name: "GOtv Smallie" },
            { id: "gotv-jinja", name: "GOtv Jinja" },
            { id: "gotv-jolli", name: "GOtv Jolli" },
            { id: "gotv-max", name: "GOtv Max" },
        ],
        startimes: [
            { id: "nova", name: "Startimes Nova" },
            { id: "basic", name: "Startimes Basic" },
            { id: "smart", name: "Startimes Smart" },
            { id: "classic", name: "Startimes Classic" },
        ],
    };

    // Automatically update amount when the user selects a plan
    useEffect(() => {
        if (variationId) {
            setAmount(priceMapping[serviceId][variationId] || '');
        }
    }, [variationId, serviceId]);


    const handleSubmit = (e) => {
        e.preventDefault();

        const newErrors = {};

        if (!smartcardNumber || !/^\d{10}$/.test(smartcardNumber)) {
            newErrors.smartcardNumber = "Smartcard number must be exactly 10 digits.";
        }

        if (!phoneNumber || !/^\d{11}$/.test(phoneNumber)) {
            newErrors.phoneNumber = "Phone number must be exactly 11 digits.";
        }

        if (!serviceId) {
            newErrors.serviceId = "Please select a service.";
        }

        if (!variationId) {
            newErrors.variationId = "Please select a plan.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);

            // Scroll to the first error field
            if (newErrors.smartcardNumber) smartcardRef.current.scrollIntoView({ behavior: 'smooth' });
            else if (newErrors.phoneNumber) phoneRef.current.scrollIntoView({ behavior: 'smooth' });
            else if (newErrors.serviceId) serviceRef.current.scrollIntoView({ behavior: 'smooth' });
            else if (newErrors.variationId) planRef.current.scrollIntoView({ behavior: 'smooth' });

            return;
        }

        setErrors({}); // Clear previous errors

        navigate("/review", {
            state: {
                type: "cabletv",
                details: {
                    smartcardNumber,
                    phoneNumber,
                    variationId,
                    serviceId,
                    amount,
                },
            },
        });

    };

    return (
        <div>
            <Account />


            <div className="cable-tv-form">

                <form onSubmit={handleSubmit}>
                    {/* Smartcard Number Input */}
                    <div ref={smartcardRef}>
                        <label className='network-label'>Smartcard Number:</label>
                        <input
                            className="styled-input airtime-input"
                            type="text"
                            inputMode="numeric"
                            maxLength={10}
                            value={smartcardNumber}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                setSmartcardNumber(value);
                            }}
                        />
                        {errors.smartcardNumber && <p className="error-input">{errors.smartcardNumber}</p>}
                    </div>


                    {/* Phone Number Input */}
                    <div ref={phoneRef}>
                        <label className='network-label'>Phone Number:</label>
                        <input
                            className="styled-input airtime-input"
                            type="text"
                            inputMode="numeric"
                            maxLength={11}
                            value={phoneNumber}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                setPhoneNumber(value);
                            }}
                        />
                        {errors.phoneNumber && <p className="error-input">{errors.phoneNumber}</p>}
                    </div>

                    {/* Service Selection */}
                    <div ref={serviceRef}>
                        <label className="network-label">Service:</label>
                        <select
                            value={serviceId}
                            onChange={(e) => setServiceId(e.target.value)}
                            className="styled-select"
                        >
                            <option value="">Select service</option>
                            <option value="gotv">GOtv</option>
                            <option value="dstv">DStv</option>
                            <option value="startimes">Startimes</option>
                        </select>
                        {errors.serviceId && <p className="error-input">{errors.serviceId}</p>}
                    </div>


                    {/* Plan Selection */}
                    <div ref={planRef}>
                        <label className="network-label">Plan:</label>
                        <select
                            value={variationId}
                            onChange={(e) => setVariationId(e.target.value)}
                            className="styled-select"
                        >
                            <option value="">Select a plan</option>
                            {cablePlans[serviceId]?.map((plan) => (
                                <option key={plan.id} value={plan.id}>
                                    {plan.name}
                                </option>
                            ))}
                        </select>
                        {errors.variationId && <p className="error-input">{errors.variationId}</p>}
                    </div>


                    {/* Amount Input - Non-editable */}
                    <div>
                        <label className="network-label">Amount:</label>
                        <input
                            className="styled-input airtime-input"
                            type="number"
                            value={amount}
                            readOnly
                            disabled
                            placeholder="₦ Amount"
                        />
                    </div>

                    <button type="submit" className="bulk-btn" disabled={loading}>
                        {loading ? "Processing..." : "Subscribe"}
                    </button>

                </form>

            </div>
        </div>
    );
};

export default CableTV;
